import React from 'react';
export var TodoListItem = function (props) {
    var label = props.label, completed = props.completed, complete = props.complete, id = props.id;
    return (React.createElement("li", { className: "todo" },
        React.createElement("label", null,
            React.createElement("input", { type: "checkbox", checked: completed, onChange: function () { return complete(id); } }),
            " ",
            label)));
};
